import { local_generation_price_upsert_generation_price_by_hash } from '@/state/generation_price/local_generation_price_upsert_generation_price_by_hash';
import { store } from '@/state/store';
import { DTO__generation_price_data } from '@shared/dto/generation_price/DTO__generation_price_data';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../_methods/add_socket_handler_client';

export function add_socket_handlers_client_generation_price() {
  add(ENE.GENERATION_PRICE_UPSERT, (items: DTO__generation_price_data[]) => store.dispatch(local_generation_price_upsert_generation_price_by_hash(items)));
}
